import React, { useState } from 'react';
import './VideoConsentInstructions.css'
import { insStep1, insStep2, insStep3, recordBtnIcon, videoInsFrame } from '../../../images/btnIcons';
import LanguageTranslater from '../../HOC/LanguageTranslater';
import { Button } from 'unified-ui-components-library'
const VideoConsentInstructions = ({ hideConsentInstructions, translate, declarationText }) => {
    const [currentStep, setCurrentStep] = useState(1)

    const getCircleClass = (step) => {
        let initialClass = 'main-vci-div'
        switch (step) {
            case 1:
                return initialClass
            case 2:
                return (initialClass + ' center')
            case 3:
                return (initialClass + ' bottom')
            default:
                return initialClass
        }
    }

    const getInsTxt = (step) => {
        switch (step) {
            case 1:
                return translate('instruction_text_1')
            case 2:
                return translate('instruction_text_2').replaceAll("'",'"')
            case 3:
                return translate('instruction_text_3')
            default:
                return translate('Skip')
        }

    }

    const getStepDirImg = (step) => {
        switch (step) {
            case 1:
                return insStep1
            case 2:
                return insStep2
            case 3:
                return insStep3
            default:
                break
        }
    }

    const handleNextAndPrev = (dir) => {
        if (dir === 'next') {
            if ((currentStep + 1) <= 3) {
                setCurrentStep(currentStep + 1)
            }
            if (currentStep === 3) {
                hideConsentInstructions()
            }
        } else {
            if ((currentStep - 1) > 0) {
                setCurrentStep(currentStep - 1)
            }
            if (currentStep === 1) {
                hideConsentInstructions()
            }
        }
    }


    return (
        <div className={getCircleClass(currentStep)}>
            <div className={'blue-circle-frame'}></div>
            <div className='vci-steps-cntnr'>
                <p className='head' >
                    <span>{translate("Steps for Video Consent")}</span>
                    <span className='current-step' >{currentStep}<span className='total-steps'>/3</span></span>
                </p>
                <p className='video-ins-txt'>
                    {getInsTxt(currentStep)}
                    <img className='ins-dir-icn' src={getStepDirImg(currentStep)} alt='step_dir_icn' />
                </p>
                <div className='ins-btns'>
                    <Button
                        buttonType='outline'
                        className='next'
                        onClick={() => handleNextAndPrev('next')}
                    >
                        {currentStep < 3 ? translate('Next') : translate('Got it')}
                    </Button>
                    <Button
                        className='skip'
                        onClick={() => handleNextAndPrev('prev')}
                        buttonType='neutralLink'
                    >
                        {currentStep < 2 ? translate("Skip") : translate('Previous')}
                    </Button>
                </div>
            </div>
            <div className='background-ins-frame' >
                <div className='new-ui text-container'>
                    <div className='textBox'>
                        <p className='read-below-text'>{translate('Record_statement_in_your_voice')}:</p>
                        <p>
                            {declarationText}
                        </p>
                    </div>

                </div>
                <div className='bg-gray-cntr'>
                <div className='frame-n-btn-cntnr' >
                    <img className='demo-frm' src={videoInsFrame} alt='video_rec_ins_frame' />
                    <img className='demo-rec-btn' src={recordBtnIcon} alt='start_rec_icn' />
                    <div className='demo-text'>{translate("Start Recording")}</div>
                </div>
                </div>
            </div>
        </div>
    );
}

export default LanguageTranslater(VideoConsentInstructions);